import controller from './kpath.controller';
import template from './kpath.html';

export default {
	template,
	bindings: {
		onAdd:            '&?',
		onChange:         '&?ngChange',
		onDelete:         '&?',
		disabled:         '<?ngDisabled',
		kid:              '<',
		options:          '=?',
		placeholder:      '@?',
		required:         '<?ngRequired',
		validatorPathMax: '<?',
		validatorPathMin: '<?',
		values:           '<ngModel',
	},
	controller,
	require:  {
		ngModelCtrl: '?ngModel',
		parent:      '^^?kform',
	},
};
